module.exports = __webpack_public_path__ + "img/national-flight-academy.d3ec2c33.jpg";